import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube, ArrowUpRight, Lock } from "lucide-react";
import { CONTACT, RT_SPORTS, BOOKING_URL } from "../mock/mock";
import { subscribeEmail } from "./adminApi";
import { useToast } from "../hooks/use-toast";
import Logo from "../components/Logo";

const SOCIALS = [Facebook, Twitter, Instagram, Youtube];
const explore = [
  { label: "About Us", to: "/about" },
  { label: "The Courts", to: "/courts/pickleball" },
  { label: "Partners & Sponsors", to: "/partners" },
  { label: "Events & Tournaments", to: "/events" },
  { label: "Rates and Fees", to: "/rates" },
];

export default function Draft2Footer() {
  const [email, setEmail] = useState("");
  const { toast } = useToast();
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const res = await subscribeEmail(email);
      toast({ title: res.already ? "You're already subscribed!" : "You're on the list!", description: `We'll keep ${email} posted.` });
      setEmail("");
    } catch {
      toast({ title: "Couldn't subscribe", description: "Please check your email and try again." });
    }
  };

  return (
    <footer className="d2-bg border-t border-white/10 pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-display uppercase text-white text-6xl md:text-[9rem] leading-[0.82]">
            Ready to <span className="d2-shine">Rally?</span>
          </h2>
          <a href={BOOKING_URL} className="d2-btn inline-flex items-center gap-3 px-10 py-4 mt-8 text-sm">Book Now! <ArrowUpRight className="w-4 h-4" /></a>
        </div>

        <div className="grid md:grid-cols-4 gap-10 border-t border-white/10 pt-12">
          <div className="md:col-span-2">
            <Logo size={72} />
            <p className="text-white/60 mt-5 max-w-sm font-grotesk">{CONTACT.addressLine1}<br />{CONTACT.addressLine2}</p>
            <div className="flex items-center gap-3 mt-6">
              {SOCIALS.map((Icon, i) => (
                <a key={i} href="#" data-hover className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:bg-sc-lime hover:text-[#06170f] hover:border-sc-lime transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-grotesk uppercase tracking-widest text-xs text-sc-lime mb-5">Explore</h4>
            <ul className="space-y-3">
              {explore.map((l) => (
                <li key={l.label}><Link to={l.to} className="font-grotesk text-white/70 hover:text-sc-lime transition-colors">{l.label}</Link></li>
              ))}
              <li><a href={BOOKING_URL} className="font-grotesk text-white/70 hover:text-sc-lime transition-colors">Book Now!</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-grotesk uppercase tracking-widest text-xs text-sc-lime mb-5">Stay in the Loop</h4>
            <form onSubmit={subscribe} className="space-y-3">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email"
                className="w-full bg-transparent border-b border-white/25 focus:border-sc-lime outline-none py-2 text-white placeholder:text-white/40 font-grotesk" />
              <button className="d2-btn w-full py-3 text-xs">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm font-mono2">© 2025 The Supreme Courts · Owned & operated by <Link to="/about" className="text-sc-lime hover:underline">{RT_SPORTS.name}</Link></p>
          <div className="flex items-center gap-5">
            <p className="text-white/30 text-xs font-mono2 uppercase tracking-widest">Sucat · Parañaque · PH</p>
            <Link to="/admin" className="inline-flex items-center gap-1.5 text-white/40 hover:text-sc-lime transition-colors font-mono2 uppercase text-xs tracking-widest">
              <Lock className="w-3.5 h-3.5" /> Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
